import React from "react";
import serviceUnavailable from "../assets/error-screens/pam_no_data_found.svg";
import { useTranslation } from "react-i18next";
import "./no_data_found.css";
import { Icon } from "pepsico-ds";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";

const PamNoData = ({supportMail = "ITmyPAMEngineering@pepsico.com"}) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    return (
        <div className="no-data-found-container d-flex justify-content-center m-auto">
            <div className="no-data-found-content">
                <div className="w-100 pt-5"><img src={serviceUnavailable} alt="Access required" className="mx-auto d-block" /></div>
                <div className="no-data-found-main-heading">{t('')}</div>
                {/* <div className="no-data-found-sub-heading">{t("If you have any remaining service accounts, they will be onboarded into myPAM")}</div> */}
                <div className="no-data-found-sub-heading" style={{ maxWidth: "860px", margin: "12px auto 0", lineHeight: "1.6" }}>
                    You can manage your service accounts in myPAM here{" "}
                    <a href="https://mypam.intra.pepsico.com/" target="_blank" rel="noopener noreferrer">
                        https://mypam.intra.pepsico.com
                    </a>
                    . If you have any questions or issues, please reach out to us at{" "}
                    <a href={`mailto:${supportMail}`}>{supportMail}</a>
                    {" "}or{" "}
                    <a
                        href="https://teams.microsoft.com/l/channel/19%3AjTVAjA0e6OdIEigYOvH9LII9EDtdijc2iWte5mxgWVA1%40thread.tacv2/myPAM%20Support%20for%20Svc%20Accounts%20Hypercare?groupId=5621599b-7cce-4070-ab1f-acffa60a6322&tenantId=42cc3295-cd0e-449c-b98e-5ce5b560c1d3"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        myPAM Support for Svc Accounts Hypercare
                    </a>{" "}
                    Teams Channel.
                </div>
                <div className="d-flex justify-content-center" style={{gap: '10px'}}>
                    <button className="request-button" style={{width: 'auto', padding: "8px 24px", fontWeight: '700'}} onClick={() => navigate('/home')}>
                        <Icon
                        alt="alt value"
                        icon="arrow_backword"
                        size="medium"
                        style={{ marginRight: '4px', width: '20px' }}
                        />
                        <span>{t('auditRequest.back_to_Home')}</span>
                    </button>
                    <button className="my-request-button" style={{marginTop: '24px', marginBottom: '16px', width: 'auto', fontWeight: '700', padding: "8px 24px"}} onClick={() => window.location.href = `mailto:${supportMail}`}>
                        <span>{t('auditRequest.contact_support')}</span>
                    </button>
                </div>
            </div>
        </div>
    );
};

PamNoData.propTypes = {
    supportMail: PropTypes.string,
};

export default PamNoData;